import { defineComponent as k, resolveComponent as s, openBlock as h, createBlock as V, withCtx as r, createElementVNode as i, normalizeClass as u, createVNode as d } from "vue";
import { a as p, V as g } from "../../../VImage-b57fd9d1.js";
import O from "../../renderless/RResponsiveElement/RResponsiveElement.js";
import { _ as C } from "../../../_plugin-vue_export-helper-dad06003.js";
const o = {
  mobile: "",
  desktop: ""
}, f = k({
  name: "VResponsiveImage",
  props: {
    /**
     * Paths of the images to render, have to be delivered as an object with keys "desktop" and "mobile"
     */
    imageUrls: {
      type: Object,
      required: !0,
      default: void 0,
      validator(e) {
        return e.desktop.length > 0 || e.mobile.length > 0;
      }
    },
    /**
     * The image dimension can be configured using three different props: `aspectRatio`, `width` and `height`.
     * `aspectRatio` works properly only if the parent element's `width` is set.
     * If `aspectRatio` is provided VImage's `height` will be forced to have a value of `0` otherwise they would add up and `width`
     * will be forced to have a value of `100%` to reflect the parent's `width`.
     *
     * Renders the image as a background image, so that Safari 14 can respect the aspect ratio
     * Have to be delivered as an object with keys "desktop" and "mobile"
     */
    aspectRatios: {
      type: Object,
      default: o,
      validator(e) {
        return e.desktop || e.mobile ? e.desktop > 0 || e.mobile > 0 : !0;
      }
    },
    /**
     * Leave empty if the image is presentational (decorative only)
     */
    altTexts: {
      type: Object,
      default: o
    },
    /**
     * Role: Defines the visibility of the image to screen readers.
     * Options are:
     * Presentation = will be ignored by screen readers. Alt text is not required in this option.
     * Img = will be read by screen readers. Alt text is required.
     *
     * If role image is used, the role attribute won't be added to the DOM because is implicit with the img tag
     *
     * Default value: img.
     *
     */
    roles: {
      type: Object,
      default() {
        return { mobile: "img", desktop: "img" };
      }
    },
    /**
     * Width attribute of the img tag
     */
    widths: {
      type: Object,
      default: o
    },
    /**
     * Height attribute of the img tag
     */
    heights: {
      type: Object,
      default: o
    },
    /**
     * Defines the border shape of the image.
     * Options are: AllRound or TopRound.
     * Default is: AllRound
     */
    borders: {
      type: Object,
      default() {
        return {
          mobile: p.AllRound,
          desktop: p.AllRound
        };
      }
    }
  },
  components: {
    RResponsiveElement: O,
    VImage: g
  },
  methods: {
    /*
     * Method for delivering the right viewMode-value of the passed property and delivering fallbacks automatically.
     */
    outputCorrectValuesOrFallback(e, t) {
      return !e.desktop && !e.mobile || t !== "desktop" && t !== "mobile" ? void 0 : {
        desktop: e.desktop ? e.desktop : e.mobile,
        mobile: e.mobile ? e.mobile : e.desktop
      }[t];
    }
  }
});
function R(e, t, m, n, b, F) {
  const a = s("VImage"), c = s("RResponsiveElement");
  return h(), V(c, null, {
    desktop: r(({ classDesktop: l }) => [
      i("div", {
        class: u(l)
      }, [
        d(a, {
          image: e.outputCorrectValuesOrFallback(e.imageUrls, "desktop"),
          aspectRatio: e.outputCorrectValuesOrFallback(e.aspectRatios, "desktop"),
          altText: e.outputCorrectValuesOrFallback(e.altTexts, "desktop"),
          role: e.outputCorrectValuesOrFallback(e.roles, "desktop"),
          width: e.outputCorrectValuesOrFallback(e.widths, "desktop"),
          height: e.outputCorrectValuesOrFallback(e.heights, "desktop"),
          border: e.outputCorrectValuesOrFallback(e.borders, "desktop")
        }, null, 8, ["image", "aspectRatio", "altText", "role", "width", "height", "border"])
      ], 2)
    ]),
    mobile: r(({ classMobile: l }) => [
      i("div", {
        class: u(l)
      }, [
        d(a, {
          image: e.outputCorrectValuesOrFallback(e.imageUrls, "mobile"),
          aspectRatio: e.outputCorrectValuesOrFallback(e.aspectRatios, "mobile"),
          altText: e.outputCorrectValuesOrFallback(e.altTexts, "mobile"),
          role: e.outputCorrectValuesOrFallback(e.roles, "mobile"),
          width: e.outputCorrectValuesOrFallback(e.widths, "mobile"),
          height: e.outputCorrectValuesOrFallback(e.heights, "mobile"),
          border: e.outputCorrectValuesOrFallback(e.borders, "mobile")
        }, null, 8, ["image", "aspectRatio", "altText", "role", "width", "height", "border"])
      ], 2)
    ]),
    _: 1
  });
}
const E = /* @__PURE__ */ C(f, [["render", R]]);
export {
  E as default
};
